import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=230af25a&scoped=true"
import script from "./Subheader.vue?vue&type=script&lang=js"
export * from "./Subheader.vue?vue&type=script&lang=js"
import style0 from "./Subheader.vue?vue&type=style&index=0&id=230af25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230af25a",
  null
  
)

export default component.exports